import asBentoPage from 'common/bento/hoc/asBentoPage';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

interface ProfileHelperMandateeProps {
  onSelectCapitalDeposit: () => void;
}

const ProfileHelperMandatee = asBentoPage<ProfileHelperMandateeProps>(
  ({ Layout, onSelectCapitalDeposit }) => (
    <Layout data-testid="profile-helper-mandatee" nav={<OBNavigation />}>
      <Header title={locales.title} />

      <SunshineCard.Group isBoxed={false} marginBottom="space-16">
        <SunshineCard
          isBoxed={false}
          onClick={onSelectCapitalDeposit}
          paddingY="space-16"
          title={locales.capitalDeposit.title}
        >
          <SunshineCard.Slot name="aside">
            <SquircleIcon name="file" />
          </SunshineCard.Slot>

          <SunshineCard.Content>
            <SunshineCard.Text>
              {locales.capitalDeposit.subtitle}
            </SunshineCard.Text>
          </SunshineCard.Content>

          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard
          isBoxed={false}
          paddingY="space-16"
          title={locales.companyCreation.title}
        >
          <SunshineCard.Slot name="aside">
            <SquircleIcon name="flash" />
          </SunshineCard.Slot>

          <SunshineCard.Content>
            <SunshineCard.Text>
              {locales.companyCreation.subtitle}
            </SunshineCard.Text>
            <SunshineCard.Text color="blue.700">
              {locales.soon}
            </SunshineCard.Text>
          </SunshineCard.Content>
        </SunshineCard>
      </SunshineCard.Group>

      <Text marginBottom="space-8" size="sm" variant="light">
        {locales.companyCreationSectionHeader}
      </Text>

      <SunshineCard
        isBoxed={false}
        paddingY="space-16"
        title={locales.accountOpening.title}
      >
        <SunshineCard.Slot name="aside">
          <SquircleIcon name="card-recto" />
        </SunshineCard.Slot>

        <SunshineCard.Content>
          <SunshineCard.Text>
            {locales.accountOpening.subtitle}
          </SunshineCard.Text>
          <SunshineCard.Text color="blue.700">{locales.soon}</SunshineCard.Text>
        </SunshineCard.Content>
      </SunshineCard>
    </Layout>
  ),
);

export default ProfileHelperMandatee;
